import React from 'react';
import useHook from './useHook';
import styles from './styles.module.scss';

type ControlesCarritoProps = {
    producto: any
    leftAlign?: boolean
    mayorista?: boolean
}

const ControlesCarrito = ({ producto, leftAlign, mayorista }: ControlesCarritoProps) => {

  const { cantidadCurrent, dec, inc } = useHook({ producto, mayorista });

  return (<>
    <div className={`${styles.contenedor} ${leftAlign ? styles.contenedorLeft : ''}`}>
      <button
        className={`${styles.botoncito} ${styles.botoncitoLeft}`}
        aria-label='Quitar'
        onClick={() => dec()}
      >-</button>
      <div className={styles.unidad} suppressHydrationWarning>{cantidadCurrent}</div>
      <button
        className={`${styles.botoncito} ${styles.botoncitoRight}`}
        aria-label='Agregar'
        onClick={() => inc()}
      >+</button>
    </div>
  </>);
};

export default ControlesCarrito;
